<template>
  <BittsCollapse
    v-model:is-open="isOpen"
    :hide-chevron="true"
    class="irp-all-fields-collapse"
    data-testid="irp-all-fields-collapse"
  >
    <template #title>
      <button
        type="button"
        class="irp-all-fields-collapse__toggle"
        :aria-expanded="isOpen"
        @click.stop="isOpen = !isOpen"
      >
        <FontAwesomeIcon
          :icon="['fak', 'chevron-down']"
          class="irp-all-fields-collapse__chevron"
          :class="{ 'rotate-180': isOpen }"
        />
        <span class="irp-all-fields-collapse__title">{{ title }}</span>
      </button>
    </template>
    <IRPFieldGrid :fields="fields" :has-card="false" />
  </BittsCollapse>
</template>

<script setup lang="ts">
import { BittsCollapse } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

import type { RecordFieldType } from '@/types/individual_record';

import IRPFieldGrid from './IRPFieldGrid.vue';

const { fields } = defineProps<{
  fields: RecordFieldType[];
}>();

const isOpen = ref(false);

const title = computed(() =>
  isOpen.value ? 'Collapse' : `See all fields (${fields.length})`,
);
</script>

<style lang="pcss" scoped>
@reference "../../../css/theme.css";

.irp-all-fields-collapse :deep(.bitts-collapse__header) {
  @apply h-auto;
}

.irp-all-fields-collapse :deep(.bitts-collapse__prefix-wrapper) {
  @apply hidden;
}

.irp-all-fields-collapse__toggle {
  @apply inline-flex items-center gap-4 appearance-none border-0 bg-transparent p-0 cursor-pointer;
}

.irp-all-fields-collapse__toggle:focus-visible {
  @apply outline-2 outline-offset-2 outline-neutral-border-focus rounded-4;
}

.irp-all-fields-collapse__chevron {
  @apply text-12 text-neutral-accent transition-transform duration-200;
}

.irp-all-fields-collapse__title {
  @apply text-sm font-semibold text-neutral-text;
}

.irp-all-fields-collapse :deep(.bitts-collapse__content) {
  @apply pl-16 pt-16;
}
</style>
